import { first } from 'rxjs';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  farmerAppDetails: any=[];
  farmerDetails: any;
  formData: any;
  village: any;
  villageList = [];
  filteredData: any[];
  isAtalbhujal: any;
  farmerId: any;
  farmerMobile: any;
  applicationDetails: any;
  appId: any;
  miDetailsByAppId: any;
  _appID: any;
  public loading: boolean = false;
  

  constructor(public router: Router, private dashboard: DashboardService, private _personalDetalSer: FarmersDetailsService, private confirmationService: ConfirmationService,
    private productService: BankDetailService,  private deptDashBoardService: DepartmentDashboardService,  private messageService: MessageService,private cryptoJsService: CryptoJsService, private cdref: ChangeDetectorRef, private activityRecordService : ActivityRecordService,private loader: AppLoaderService
    ) { }

  ngOnInit(): void {
    let AtalbhujalRole: any = sessionStorage.getItem('isAtalBhujal');
  //   let sessionToken = sessionStorage.getItem('token');
  //   let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
  //  this.appId= JSON.parse(payload)?.sub;
 // this.appId=this.appID;

    if (AtalbhujalRole == "1") {
      this.isAtalbhujal = true;
      let userId = sessionStorage.getItem('userId');
      this.getFarmerAppDetailsByAtalLogin(userId);
    }
    else {
      this.farmerMobile = sessionStorage.getItem('farmerPh');
      this.getFarmerPhone();
    }
   
    //test start
    //this.farmerAppDetails.forEach(e => {
     // this.getMIDetailByAppID(this.farmerAppDetails.appID);
   // })
   //this.getMIDetailByAppID();

    //test end
    // this.getMIDetailByAppID(this._appID);
    // console.log("FarmerAppDetails",this.farmerAppDetails[0]?.appID);
    //  this._appID=this.farmerAppDetails[0]?.appID;
    // console.log("_appID",this._appID)
    //   this.dashboard
    //     .getMIDetailByAppID(this._appID)
    //     .pipe(first())
    //     .subscribe({
    //       next: (res) => {
    //         this.miDetailsByAppId = res;
    //         console.log("miDetailsByAppId", this.miDetailsByAppId);
    //       },
    //       error: (err) => {
    //         console.log("error", err);
    //         this.messageService.add({
    //           severity: 'error',
    //           summary: 'Error Message',
    //           detail: err,
    //         });
    //       },
    //     });
  
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  getFarmerAppDetailsByAtalLogin(userId: any) {
    // this.loader.start();
    this.loading = true;
    this.dashboard.getApplicationByAtal(userId)
    .pipe(first())
    .subscribe({
      next : (res) => {
        res.forEach(e=>{
            e.registerationDate=new Date(e.registerationDate)
            e.registerationDate_filter=e.registerationDate.toString().substring(4, 15)
           })
        this.farmerAppDetails = res;
        // this.loader.close();
        this.loading = false;
      console.log("appdetails", this.farmerAppDetails);
      },
      error: () =>{
        // this.loader.close();
        this.loading = false;
      }
    })
  }

  onAtalbhujalFarmer() {
    sessionStorage.removeItem('farmerDetails');
    sessionStorage.removeItem('userID');
    sessionStorage.removeItem('farmerPh');
    sessionStorage.removeItem("isFarmerLogin");
    this.router.navigate(['/phone-login']);
  }

  getFarmerPhone() {
    // this.loader.start();
    this.loading = true;
    this.productService.getFarmerIdByMobileNo(this.farmerMobile).subscribe(resp => {
      // this.loader.close();
      this.loading = false;
      if (resp.statusCode === 200) {
        this.activityRecordService.activityRecord(this.farmerMobile, 'Dashboard', '', new Date(), 'Success');
        let far = JSON.parse(resp.data);
        if (far.length > 0) {
          this.farmerId = far[0].Farmer_ID;
          this.getDetailsByFarmerId();
          sessionStorage.setItem("farmerId", this.farmerId);
        }
      }
      else{
        this.activityRecordService.activityRecord(this.farmerMobile, 'Dashboard', '', new Date(), 'Invalid');
      }
    }, err => {
      // this.loader.close();
      this.loading = false;
    })
  }
  getDetailsByFarmerId() {
    // this.loader.start();
    this.loading = true;
    this.dashboard.getApplicationByFarmerId(this.farmerId)
    .pipe(first())
      .subscribe({
        next: (res) => {
          res.forEach(e=>{
            e.registerationDate=new Date(e.registerationDate)
            e.registerationDate_filter=e.registerationDate.toString().substring(4, 15)
           })
           
          console.log(res,"result")
          this.farmerAppDetails = res;
          // this.loader.close();
          this.loading = false;     
        },
        error: () => {
        // this.loader.close();
        this.loading = false;
        }
      });
  }

  getVillageData() {
    // this.loader.start();
    this.loading = true;
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      console.log(res);
      this.villageList = res;
      // this.loader.close();
      this.loading = false;
      this.FarmersDetailsService();
      this.filteredData = [...this.villageList];
      console.log("fil", this.filteredData);
      if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
    }, err => {
      // this.loader.close();
      this.loading = false;
    })
  }
  FarmersDetailsService() {
    // this.loader.start();
    this.loading = true;
    this.dashboard.GetAllFarmerDetails()
    .pipe(first())
    .subscribe({
      next: (res) => {
        console.log("details", res);
        this.farmerDetails = res;
        // this.loader.close();
        this.loading = false;
        this.formData = this.farmerDetails.find(x => x.Farmer_ID == this.farmerDetails[0].Farmer_ID);
        this.village = this.villageList.find(x => x.Code == this.formData.Village_Code);
        // debugger;
        console.log("formData", this.village);
      }, 
      error: () => {
        // this.loader.close();
        this.loading = false;
      }
    })
  }

  editForm(appId) {
    this.router.navigate(['farmers-application', appId])
  }

  deleteForm(appId) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        console.log("Hello")
        console.log(appId)
        // this.loader.start();
        this.loading = true;
        this.dashboard.deleteFarmerApplicationByAppId(appId)
          .pipe(first())
          .subscribe({
            next: () => {
              // this.loader.close();
            this.loading = false;
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Application deleted Successfully.' });
      
            },
            error: () => {
              // this.loader.close();
            this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Application Not Deleted.' });

            }
          });
      }
    });
  }

  // getMIDetailByAppID() {
  //  }

  // printForm(appId,vendorId,programId,userId,autoId,statusCode) {
  //   let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
  //   this.router.navigate(['dashboard', 'print',appId,vendorId,programId,userId,autoId], { queryParams: { statusCode: statusCodeEncrypted } });
  // }
   printForm(appId,statusCode) {
    if(appId){
      // this.loader.start();
      this.loading = true;
      this.dashboard
      .getMIDetailByAppID(appId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          // this.loader.close();
          this.loading = false;
          let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
          this.router.navigate(['dashboard', 'print',appId,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId], { queryParams: { statusCode: statusCodeEncrypted } });
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          console.log("error", err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    // let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
    //   this.router.navigate(['dashboard', 'print',appId], { queryParams: { statusCode: statusCodeEncrypted } });
    }
     }
     }


